/**
 * HTTP errors thrown by @ag-ui/client's HttpAgent.
 * The SDK attaches `status` and `payload` to a plain Error —
 * there is no exported class, so we mirror the shape here.
 */
export interface HttpError extends Error {
  status: number;
  payload: unknown;
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof Error && 'status' in error && typeof error.status === 'number' && 'payload' in error;
}

// DOMException isn't reliably `instanceof DOMException` across runtimes/polyfills (Node's fetch,
// jsdom, and hand-rolled abort rejections all disagree), so key off the standardized `name` instead.
export function isAbortError(error: unknown): error is DOMException {
  return typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError';
}
